import BookingData from "@/classes/BookingData"
import Traveller, {ITraveller} from "@/model/Traveller"

import { QuoteState, TravellerQuote } from "@requests"

import getAgeFromBirthdate from "@/logic/getAgeFromBirthdate";
import GenderEnum from "@/config/genderEnum";
import { Participant } from "@/classes/Participant";


const processTravellers = (bookingData: BookingData, sourceObj: QuoteState) => {
    // Load Participants from localstorage
    const localStorageParticipants: Participant[] = JSON.parse(localStorage.getItem('participants') || '[]') as Participant[];

    // create traveller objects
    sourceObj.travellers.forEach(async (travellerObj: TravellerQuote, travellerIndex: number) => {
        const traveller: ITraveller = new Traveller(travellerObj.id, travellerObj.type, travellerObj.birthDate)
        // save the index of the object to be able to display stuff like "Participant 3" on the UI
        traveller.setIndex(travellerIndex)
        // save source object to use for modification and saving via API
        traveller.setBaseTravellerQuoteObject(travellerObj)
        // set age
        traveller.setAge(getAgeFromBirthdate(travellerObj.birthDate))
                
        if (travellerObj.firstName) traveller.setFirstName(travellerObj.firstName || "");
        if (travellerObj.lastName) traveller.setLastName(travellerObj.lastName || "");
        if (travellerObj.gender) traveller.setGender(travellerObj.gender as GenderEnum);
        // save traveller in booking data
        bookingData.travellersArr.push(traveller)
        bookingData.travellersMap.set(traveller.getId(), traveller)
    })

}

export default processTravellers